import React, { useState } from "react";

interface TextInputProps {
  id: string;
  type: string;
  label?: string;
  placeholder?: string;
  icon?: React.ReactNode;
  error?: string;
  register?: any; // From react-hook-form
  value?: any;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextInput: React.FC<TextInputProps> = ({
  id,
  type,
  label,
  placeholder,
  icon,
  error,
  register,
  value,
  onChange,
  name,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  // Handle password visibility toggle
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="mb-4 w-[100%]">
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label}
      </label>
      <div className="relative min-w-full">
        {icon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            {icon}
          </div>
        )}
        <input
          id={id}
          type={type === "password" && showPassword ? "text" : type}
          placeholder={placeholder}
          value={value}
          {...register}
          autoComplete={
            type === "password"
              ? "new-password"
              : type === "email"
              ? "new-email"
              : "off"
          }
          className={`min-w-[100%] md:w-[450px] px-4 py-2 h-[60px] rounded-lg border ${
            icon ? "pl-10" : ""
          } ${
            error
              ? "border-red-500 focus:border-red-500"
              : "border-gray-300 focus:border-primary"
          } focus:outline-none`}
          onChange={onChange}
          name={name}
        />
        {type === "password" && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-600"
          >
            {showPassword ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.05 10.05 0 011.875-3.825m1.255-1.255A9.973 9.973 0 0112 5c4.477 0 8.268 2.943 9.542 7-.323 1.027-.781 1.994-1.342 2.875M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17.657 6.343L6.343 17.657"
                />
              </svg>
            )}
          </button>
        )}
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default TextInput;
